// extracted by mini-css-extract-plugin
module.exports = {"page":"_1cDax11fydJOPQm750DiUm","logo":"t_N3dXboXPToIV-5ipe6R","text":"x72mbty5t1EfAlN8CRTLI","icon":"_1D34XGD00YESE7qfB6WXe_"};